import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'NpaNpxPipe'})
export class SplitNpaNpxPipe implements PipeTransform {
    transform(value: any, formatMsisdn: boolean = false): any {
        if (formatMsisdn) {
          return value.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        } else {
            return value.match(/.{1,3}/g).join('-');
        }
    }
}
